<template>
  <div class="user">
    <self-title :title="titles" :fixed="true" @titleClick="titleClick"></self-title>
    <transition name="slide-fade">
      <div class="main" v-show="web === 'list'">
        <div class="title">收款统计</div>
        <el-form
          class="search-form"
          ref="searchForm"
          :inline="true"
          :model="searchForm"
          label-width="100px"
          @submit.native.prevent="false"
        >
          <!-- <el-col :xs="24" :sm="12">
            <el-form-item class="show-pc roleName" label="区域">
              <el-cascader class="width-100" v-model="searchForm.qy" placeholder="请选择区域" :options="options"
                           filterable @change="searchQyChange">
              </el-cascader>
            </el-form-item>
            <el-form-item class="show-phone roleName" label="区域">
              <div @click="popupShowState=true">
                <el-input v-model="searchForm.qy2" :disabled="true"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-form-item label="业务类型" class="ywlx">
            <el-select v-model="searchForm.ywlx" placeholder="请选择">
              <el-option :label="item.roleName" :value="item.roleId" v-for="item in yws" :key="item.roleId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户经理" class="khjl">
            <el-select v-model="searchForm.khjl" placeholder="请选择">
              <el-option :label="item.roleName" :value="item.roleId" v-for="item in persons" :key="item.roleId">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="公司名称">
            <el-input
              v-model="searchForm.customerName"
              size="small"
              placeholder="请输入公司名称"
              clearable
              @keyup.enter.native="search(1)"
            ></el-input>
          </el-form-item>
          <el-form-item label="收费项目名">
            <el-input
              v-model="searchForm.payProject"
              size="small"
              placeholder="请输入收费项目名"
              clearable
              @keyup.enter.native="search(1)"
            ></el-input>
          </el-form-item>
          <el-form-item label="收款时间" prop="payTime">
            <el-date-picker
              v-model="searchForm.sksj"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd hh:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small"
              :picker-options="pickerOptions"
              @change="search(1)"
            ></el-date-picker>
          </el-form-item>
          <!-- <el-form-item class="show-phone" label="开始日期">
            <div @click="popupShowState2=true">
              <el-input v-model="searchForm.payTimeA" :disabled="true"></el-input>
            </div>
          </el-form-item>
          <el-form-item class="show-phone" label="结束日期">
            <div @click="popupShowState3=true">
              <el-input v-model="searchForm.payTimeB" :disabled="true"></el-input>
            </div>
          </el-form-item> -->
          <el-form-item class="btn">
            <el-button type="primary" size="small" class="search" @click="search">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="tableData" height="72vh" style="width: 100%" @row-click="queryProject2">
          <el-table-column label="公司名称">
            <template slot-scope="scope">
              <span>{{ scope.row.customerName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="收费项目名称">
            <template slot-scope="scope">
              <span>{{ scope.row.payProject }}</span>
            </template>
          </el-table-column>
          <el-table-column label="付款时间">
            <template slot-scope="scope">
              <span>{{ scope.row.payTime && scope.row.payTime.substring(0, 10) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="付款期止">
            <template slot-scope="scope">
              <span>
                {{ scope.row.payPeriodStart && scope.row.payPeriodStart.substring(0, 10) }} -
                {{ scope.row.payPeriodEnd && scope.row.payPeriodEnd.substring(0, 10) }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="付款总金额">
            <template slot-scope="scope">
              <span>{{ scope.row.amount }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="客户经理">
            <template slot-scope="scope">
              <span>{{ scope.row.accountManager }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="操作" width="210px">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" plain @click="queryProject(scope.row, 'edit')">编辑</el-button>
              <el-button size="mini" type="danger" plain @click="handleDelete(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <p class="text-primary">当前页 - 付款总金额：{{ allNum }}</p>
        <div class="page">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[100, 200, 500, 1000, 2000]"
            :page-size="pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </transition>
    <transition name="slide-fade">
      <div class="main" v-show="web === 'detail'">
        <div class="title">收费项目</div>
        <table class="detail">
          <tr>
            <td>公司名称: {{ addForm.customerName }}</td>
            <td>收费项目名称: {{ addForm.payProject }}</td>
          </tr>
          <tr>
            <td>付款时间: {{ addForm.payTime }}</td>
            <td>总金额: {{ addForm.amount }} 元</td>
          </tr>
          <tr>
            <td>实收金额: {{ addForm.realAmount }}</td>
            <td>尾款: {{ addForm.finalPayment }} 元</td>
          </tr>
          <tr>
            <td>折扣: {{ addForm.discount }} 折</td>
            <td>总金额: {{ addForm.amount }} 元</td>
          </tr>
          <tr>
            <td>付款周期始: {{ addForm.payPeriodStart }}</td>
            <td>付款周期止: {{ addForm.payPeriodEnd }}</td>
          </tr>
          <!-- <tr>
            <td>公司法人: {{ addForm.legalPerson }}</td>
            <td>纳税性质: {{ addForm.taxNature }}</td>
          </tr> -->
          <tr>
            <!-- <td>客户经理: {{ addForm.accountManager }}</td> -->
            <td colspan="2">收款经办人: {{ addForm.operName }}</td>
          </tr>
          <tr>
            <td colspan="2">备注: {{ addForm.remark }}</td>
          </tr>
        </table>

        <el-button type="primary" size="small" class="search" @click="back">返回列表</el-button>
      </div>
    </transition>
    <transition name="slide-fade">
      <div class="main" v-show="web === 'edit'">
        <div class="drawer-box">
          <el-form ref="payRecord" :model="payRecord" label-width="100px" :rules="rules">
            <div class="title" style="padding:8px">收款登记</div>
            <el-row>
              <el-col :xs="24" :sm="24">
                <el-form-item label="客户名称" prop="customerName">
                  <el-input
                    type="text"
                    size="small"
                    :disabled="true"
                    v-model="payRecord.customerName"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-form-item label="收款项目" prop="payProject">
                  <el-input type="text" size="small" v-model="payRecord.payProject" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-form-item label="金额" prop="amount">
                  <el-input-number
                    v-model="payRecord.amount"
                    :min="0"
                    :step="0.01"
                    step-strictly
                    placeholder="请输入金额"
                  ></el-input-number>
                  <span slot="append">元</span>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-form-item label="折扣" prop="discount">
                  <el-input-number
                    v-model="payRecord.discount"
                    :min="0.1"
                    :max="10"
                    :step="0.1"
                    step-strictly
                    placeholder="请输入金额"
                  ></el-input-number>
                  <span slot="append">折</span>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-form-item label="实收金额" prop="realAmount">
                  <el-input-number
                    v-model="payRecord.realAmount"
                    :min="0"
                    :step="0.01"
                    step-strictly
                    placeholder="请输入金额"
                  ></el-input-number>
                  <span slot="append">元</span>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-form-item label="尾款" prop="finalPayment">
                  <el-input-number
                    v-model="payRecord.finalPayment"
                    :min="0"
                    :step="0.01"
                    step-strictly
                    placeholder="请输入金额"
                  ></el-input-number>
                  <span slot="append">元</span>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-form-item label="收款经办人">
                  <el-input type="text" size="small" :value="userInfo.name" :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-form-item class="show-pc" label="合同时间" prop="payTime">
                  <el-date-picker
                    v-model="payRecord.payRecordTime"
                    type="daterange"
                    range-separator="至"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="payRecordTimeChange"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-form-item label="备注" prop="remark">
                  <el-input size="small" type="textarea" v-model="payRecord.remark" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-form-item>
                  <el-button type="primary" size="small" class="save" @click="addPaySave('payRecord')">保存 </el-button>
                  <el-button type="primary" size="small" class="search" @click="back">返回列表</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </transition>
    <!-- <transition name="slide-fade">
      <div class="main" v-show="web==='detail'">
        <div class="title">收费项目</div>
        <el-table :data="projects" height="61vh" style="width: 100%">
          <el-table-column label="收费项目">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="金额">
            <template slot-scope="scope">
              <span>{{ scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              <span>{{ scope.row.createTime }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="primary" size="small" class="search" @click="back">返回列表</el-button>
      </div>
    </transition> -->
    <van-popup v-model="popupShowState" position="bottom" :style="{ height: '50%' }">
      <van-picker
        ref="picker"
        show-toolbar
        title="区域"
        :columns="options"
        @confirm="pickerConfirm"
        @cancel="pickerCancel"
      />
    </van-popup>
    <van-popup v-model="popupShowState2" position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker
        v-model="searchForm.payTimeA2"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        cancel-button-text="清空"
        @confirm="pickerConfirm2"
        @cancel="pickerCancel2"
      />
    </van-popup>
    <van-popup v-model="popupShowState3" position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker
        v-model="searchForm.payTimeB2"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        cancel-button-text="清空"
        @confirm="pickerConfirm3"
        @cancel="pickerCancel3"
      />
    </van-popup>
  </div>
</template>

<script>
import cityData from '../utils/Data'

// import selfTitle from '../components/Title'
export default {
  name: 'User',
  // components: {
  //   selfTitle
  // },
  data() {
    return {
      userInfo: {},
      titles: ['收款统计'],
      searchForm: {
        customerName: '',
        payProject: '',
        payTimeA: '',
        payTimeB: '',
        payTimeA2: new Date(),
        payTimeB2: new Date(),
        area1: '',
        area2: '',
        area3: '',
        name: '',
        legalPerson: '',
        accountManagerId: ''
      }, //
      addForm: {},
      web: 'list',
      projects: [],
      options: cityData,
      yws: [
        { roleId: '1', roleName: '注册' },
        { roleId: '2', roleName: '变更注销' },
        { roleId: '3', roleName: '资质代办' },
        { roleId: '4', roleName: '代理记账' }
      ],
      areas: [
        { roleId: '1', roleName: '姑苏区' },
        { roleId: '2', roleName: '园区' },
        { roleId: '3', roleName: '高新区' },
        { roleId: '4', roleName: '吴中区' },
        { roleId: '5', roleName: '相城区' },
        { roleId: '6', roleName: '吴江区' },
        { roleId: '7', roleName: '昆山' },
        { roleId: '8', roleName: '常熟' },
        { roleId: '9', roleName: '太仓' },
        { roleId: '10', roleName: '张家港' }
      ],
      persons: [{ roleId: '1', roleName: '张三' }],
      cycle: [
        { roleId: '1', roleName: '30天内到期' },
        { roleId: '2', roleName: '60天内到期' },
        { roleId: '3', roleName: '90天内到期' }
      ],
      tableData: [],
      currentPage: 1,
      pageSize: 100,
      total: 0,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2099, 0, 1),
      currentDate: new Date(),
      popupShowState: false,
      popupShowState2: false,
      popupShowState3: false,
      allNum: 0,
      payRecord: {
        customerName: '', // 客户名称
        payProject: '', // 收费项目名称
        amount: '', // 总金额
        realAmount: '', // 实收金额
        discount: 10, // 折扣
        finalPayment: '', // 尾款
        payPeriodStart: '', // 计费周期始
        payPeriodEnd: '', // 计费周期止
        payRecordTime: [],
        remark: ''
      },
      rules: {
        customerName: [{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        payProject: [{ required: true, message: '请输入收费项目名称', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入总金额', trigger: 'blur' }],
        realAmount: [{ required: true, message: '请输入收费金额', trigger: 'blur' }],
        discount: [{ required: true, message: '请输入折扣', trigger: 'blur' }],
        finalPayment: [{ required: true, message: '请输入尾款', trigger: 'blur' }]
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '昨天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24)
              end.setTime(end.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '今天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '上周',
            onClick(picker) {
              const oDate = new Date()
              oDate.setTime(oDate.getTime() - 3600 * 1000 * 24 * 7)

              var day = oDate.getDay()

              var start = new Date()
              var end = new Date()
              if (day === 0) {
                start.setDate(oDate.getDate())
                end.setDate(oDate.getDate() + 6)
              } else {
                start.setTime(oDate.getTime() - 3600 * 1000 * 24 * day)
                end.setTime(oDate.getTime() + 3600 * 1000 * 24 * (6 - day))
              }

              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '本周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              var thisDay = start.getDay()
              var thisDate = start.getDate()
              if (thisDay !== 0) {
                start.setDate(thisDate - thisDay)
              }
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '上月',
            onClick(picker) {
              const oDate = new Date()
              var year = oDate.getFullYear()
              var month = oDate.getMonth()
              var start, end
              if (month === 0) {
                year--
                start = new Date(year, 11, 1)
                end = new Date(year, 11, 31)
              } else {
                start = new Date(year, month - 1, 1)
                end = new Date(year, month, 0)
              }

              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '本月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setDate(1)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '上季度',
            onClick(picker) {
              var oDate = new Date()

              var thisYear = oDate.getFullYear()
              var thisMonth = oDate.getMonth() + 1

              var n = Math.ceil(thisMonth / 3) // 季度，上一个季度则-1
              var prevN = n - 1
              if (n === 1) {
                thisYear--
                prevN = 4
              }

              var Month = prevN * 3 // 月份

              var start = new Date(thisYear, Month - 3, 1)
              var end = new Date(thisYear, Month, 0)

              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '本季度',
            onClick(picker) {
              var oDate = new Date()

              var thisYear = oDate.getFullYear()
              var thisMonth = oDate.getMonth() + 1

              var n = Math.ceil(thisMonth / 3) // 季度

              var Month = n * 3 - 1

              var start = new Date(thisYear, Month - 2, 1)
              var end = new Date()

              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '去年',
            onClick(picker) {
              var oDate = new Date()
              var prevYear = oDate.getFullYear() - 1
              const end = new Date()
              const start = new Date()
              start.setFullYear(prevYear)
              start.setMonth(0)
              start.setDate(1)

              end.setFullYear(prevYear)
              end.setMonth(11)
              end.setDate(31)

              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '今年',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setMonth(0)
              start.setDate(1)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  methods: {
    titleClick(item, index) {
      console.log(item, index)
      if (item === '收款统计') {
        this.web = 'main'
        this.titles = ['收款统计'] // 导航菜单
      }
    },
    pickerConfirm(val, indexs) {
      this.searchForm.qy = val
      this.searchForm.qy2 = val.join('/')
      this.searchForm.area1 = val[0]
      this.searchForm.area2 = val[1]
      this.searchForm.area3 = val[2]
      this.popupShowState = false
    },
    pickerCancel() {
      this.searchForm.qy = []
      this.searchForm.qy2 = ''
      this.searchForm.area1 = ''
      this.searchForm.area2 = ''
      this.searchForm.area3 = ''
      this.popupShowState = false
    },
    // 区域选择
    pickerConfirm2(val, indexs) {
      const time = this.$common.timeFormat(new Date(val.replace(/\-/g, '/')), 'yyyy-MM-dd')
      console.log(val)
      this.searchForm.payTimeA = time
      if (this.searchForm.payTimeA && this.searchForm.payTimeB) {
        this.searchForm.sksj = [this.searchForm.payTimeA, this.searchForm.payTimeB]
      }
      this.popupShowState2 = false
    },
    // 开始时间
    pickerCancel2(val, indexs) {
      console.log(val)
      this.searchForm.payTimeA = ''
      this.popupShowState2 = false
    },
    // 区域选择
    pickerConfirm3(val, indexs) {
      const time = this.$common.timeFormat(new Date(val.replace(/\-/g, '/')), 'yyyy-MM-dd')
      console.log(val)
      this.searchForm.payTimeB = time
      if (this.searchForm.payTimeA && this.searchForm.payTimeB) {
        this.searchForm.sksj = [this.searchForm.payTimeA, this.searchForm.payTimeB]
      }
      this.popupShowState3 = false
    },
    // 区域选择
    pickerCancel3(val, indexs) {
      console.log(val)
      this.searchForm.payTimeB = ''
      this.popupShowState3 = false
    },
    search(page) {
      // 查询
      if (page && typeof page === 'number') {
        this.currentPage = page
      }
      this.queryFinancialHistory()
    },
    reset() {
      // 重置
      this.form = {}
    },
    detail(index, row) {
      // 编辑
      console.log(index, row)
      this.web = 'edit'
      this.titles = ['收款统计', '编辑']
      this.form2 = row
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.search()
    },
    queryFinancialHistory() {
      // 查询用户列表
      const param = {
        customerName: this.searchForm.customerName,
        payProject: this.searchForm.payProject,
        payTimeA: this.searchForm.sksj
          ? this.$common.timeFormat(new Date(this.searchForm.sksj[0].replace(/\-/g, '/')), 'yyyy-MM-dd 00:00:00')
          : '',
        payTimeB: this.searchForm.sksj
          ? this.$common.timeFormat(new Date(this.searchForm.sksj[1].replace(/\-/g, '/')), 'yyyy-MM-dd 00:00:00')
          : '',
        area1: this.searchForm.area1,
        area2: this.searchForm.area2,
        area3: this.searchForm.area3,
        name: this.searchForm.name,
        legalPerson: this.searchForm.legalPerson,
        accountManagerId: this.searchForm.accountManagerId,
        page: this.currentPage,
        limit: this.pageSize
      }
      this.$post('/financial/query', param).then(
        result => {
          if (result.status === 200) {
            this.total = result.count
            this.tableData = result.data
            let allNum = 0
            for (var i = 0; i < this.tableData.length; i++) {
              const fee = this.tableData[i].amount ? parseFloat(this.tableData[i].amount).toFixed(2) : 0
              allNum += fee * 100
            }
            this.allNum = allNum / 100
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 删除客户
    handleDelete(id) {
      this.$root.$children[0].vueConfirm(
        { message: '确认要删除此收费?' },
        () => {
          const param = {
            id: id
          }
          this.$get('/financial/delete', param).then(
            result => {
              if (result.status === 200) {
                this.search()
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        },
        () => {
          return console.log('取消删除')
        }
      )
    },
    payRecordTimeChange(val) {
      console.log(val)
      if (val) {
        this.payRecord.payPeriodStart = val[0]
        this.payRecord.payPeriodEnd = val[1]
      }
    },
    queryProject2(row, column, event) {
      this.queryProject(row, 'detail')
    },
    queryProject(row, type) {
      this.addForm = JSON.parse(JSON.stringify(row))
      this.payRecord = JSON.parse(JSON.stringify(row))
      for (const i in row) {
        this.payRecord[i] = row[i]
      }
      this.titles = ['收款统计', type === 'edit' ? '编辑' : '详细']
      this.web = type
      this.payRecord.payRecordTime = [this.payRecord.payPeriodStart, this.payRecord.payPeriodEnd]
      this.payRecord = JSON.parse(JSON.stringify(this.payRecord))
      // // 查询用户列表
      // const param = {
      //   id: id
      // }
      // this.$get('/financialHistory/queryProject', param).then(
      //   result => {
      //     if (result.status === 200) {
      //       this.titles = ['收款统计', '详细']
      //       this.projects = result.data
      //       this.web = 'detail'
      //     } else {
      //       this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
      //     }
      //   },
      //   error => {
      //     this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
      //   }
      // )
    },
    addPaySave() {
      if (!this.payRecord.payRecordTime[0]) {
        this.payRecord.payPeriodStart = ''
        this.payRecord.payPeriodEnd = ''
      } else {
        this.payRecord.payPeriodStart = this.$common.timeFormat(
          new Date(this.payRecord.payRecordTime[0].replace(/\-/g, '/')),
          'yyyy-MM-dd 00:00:00'
        )
        this.payRecord.payPeriodEnd = this.$common.timeFormat(
          new Date(this.payRecord.payRecordTime[1].replace(/\-/g, '/')),
          'yyyy-MM-dd 00:00:00'
        )
      }
      this.$refs.payRecord.validate(valid => {
        if (valid) {
          const param = {
            id: this.payRecord.id, // 收费项目id
            caseId: this.payRecord.caseId, // 客户id
            customerId: this.payRecord.customerId, // 客户id
            customerName: this.payRecord.customerName, // 客户名称
            payProject: this.payRecord.payProject, // 收费项目名称
            amount: this.payRecord.amount, // 总金额
            realAmount: this.payRecord.realAmount, // 实收金额
            discount: this.payRecord.discount, // 折扣
            finalPayment: this.payRecord.finalPayment, // 尾款
            payPeriodStart: this.payRecord.payPeriodStart, // 计费周期始
            payPeriodEnd: this.payRecord.payPeriodEnd, // 计费周期止
            operName: this.userInfo.name,
            operId: this.userInfo.id,
            remark: this.payRecord.remark
          }
          this.$post('/financial/updatePayRecord', param).then(
            result => {
              if (result.status === 200) {
                this.drawer = false
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        } else {
          console.log(valid)
        }
      })
    },
    back() {
      this.web = 'list'
      this.queryFinancialHistory()
    }
  },
  mounted() {
    if (this.$common.session.get('userInfo')) {
      this.userInfo = this.$common.session.get('userInfo')
    }
    this.queryFinancialHistory()
  },
  beforeDestroy() {}
}
</script>

<style lang="less" scoped>
.user {
  .main {
    height: 81vh;
  }
  .detail {
    width: 100%;
    tr {
      td {
        padding: 8px;
      }
    }
  }
}
</style>
